/* Keyless City kiosk phone page: read the QR order, collect documents (lost key), add to cart, open checkout. */
(function () {
  'use strict';
  var root = document.querySelector('[data-kp]');
  if (!root) return;
  var CFG = {};
  try { CFG = JSON.parse(document.getElementById('KioskPhoneData').textContent); } catch (e) {}
  // Only our own errors count; other sites' scripts (Shopify apps) report as "Script error." without details.
  window.addEventListener('error', function (e) {
    var file = String(e.filename || '');
    if (!/kiosk-phone/.test(file)) return;
    logIssue('error', 'js_error', e.message, { page: 'phone', file: file.split('/').pop(), line: e.lineno });
  });
  var $ = function (s) { return root.querySelector(s); };

  var KEY_TYPES = { push_start: 'Push to start', ignition: 'Turn key', remote: 'Remote' };
  var LOCATIONS = { pickup: 'Pick up at the kiosk', shop: 'At our shop', mobile: 'We come to you' };
  var WHEN = { asap: 'As soon as possible', later: 'Later today', tomorrow: 'Tomorrow' };

  function show(state) {
    root.querySelectorAll('[data-kp-state]').forEach(function (el) { el.hidden = el.dataset.kpState !== state; });
  }
  function decode(str) {
    var b64 = str.replace(/-/g, '+').replace(/_/g, '/');
    while (b64.length % 4) b64 += '=';
    var bin = atob(b64), bytes = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    return JSON.parse(new TextDecoder().decode(bytes));
  }

  /* ---------- reports to the kiosk admin (no personal details) ---------- */
  var API = String(CFG.adminUrl || '').trim().replace(/\/+$/, '').replace(/\/status$/, '');
  var order;
  function report(type, extra) {
    if (!API) return;
    var body = Object.assign({ src: 'phone', k: order && order.k, s: order && order.s, type: type }, extra || {});
    try {
      fetch(API + '/kiosk/event', { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(body), keepalive: true, credentials: 'omit' })
        .catch(function () {});
    } catch (e) { /* never block the customer */ }
  }
  function logIssue(level, code, msg, ctx) { report('log', { level: level, code: code, msg: String(msg || '').slice(0, 500), ctx: ctx || null }); }

  try {
    order = decode(new URLSearchParams(location.search).get('o') || '');
    var tooOld = !order.t || (Date.now() - order.t) > (CFG.maxAgeMinutes || 120) * 60000;
    if (!order.v || !order.q) throw new Error('invalid');
    if (tooOld) {
      logIssue('warn', 'qr_expired', 'Customer opened a QR code that is ' + Math.round((Date.now() - order.t) / 60000) + ' minutes old.');
      throw new Error('expired');
    }
  } catch (e) { show('invalid'); return; }
  // Same look as the kiosk (admin → Settings → Kiosk look).
  if (order.th === 'key2go') document.documentElement.setAttribute('data-kiosk-theme', 'key2go');
  // Kiosk admin address: this page's setting, else the one the kiosk put in the QR order.
  if (!API && /^https:\/\/[A-Za-z0-9.-]+(:\d+)?$/.test(String(order.x || ''))) API = order.x;
  report('phone_opened');

  var lost = order.svc === 'lost';
  var needDocs = typeof order.d === 'number' ? order.d === 1 : lost;   // documents follow the kiosk setting

  /* ---------- summary ---------- */
  var rows = [
    ['Car', order.car],
    ['Service', lost ? 'Lost key' : 'Spare key'],
    ['Key', order.kn || KEY_TYPES[order.kt] || order.kt],
    ['Key type', KEY_TYPES[order.kt] || order.kt],
    ['Quantity', String(order.q)],
    ['Where', order.ln || LOCATIONS[order.loc] || order.loc]
  ];
  if (order.a) rows.push(['Address', [order.a.street, order.a.city, order.a.zip].join(', ')]);
  if (order.w) rows.push(['When', WHEN[order.w] || order.w]);
  rows.push(['Name', order.n]);
  var dl = $('[data-kp-summary]');
  rows.forEach(function (r) {
    if (!r[1]) return;
    var dt = document.createElement('dt'); dt.textContent = r[0];
    var dd = document.createElement('dd'); dd.textContent = r[1];
    dl.appendChild(dt); dl.appendChild(dd);
  });
  $('[data-kp-docs]').hidden = !needDocs;
  show('form');

  /* ---------- files ---------- */
  var files = { id: null, reg: null };
  var maxBytes = (CFG.maxFileMb || 15) * 1024 * 1024;

  function shrinkImage(file) {
    // Phone photos can be 5-10 MB. Resize to max 1800px so uploads are quick on mobile data.
    return new Promise(function (resolve) {
      if (!/^image\//.test(file.type) || /gif|svg/.test(file.type)) return resolve(file);
      var url = URL.createObjectURL(file), img = new Image();
      img.onload = function () {
        var scale = Math.min(1, 1800 / Math.max(img.width, img.height));
        var c = document.createElement('canvas');
        c.width = Math.round(img.width * scale); c.height = Math.round(img.height * scale);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        c.toBlob(function (blob) {
          if (!blob) return resolve(file);
          resolve(new File([blob], (file.name || 'photo').replace(/\.\w+$/, '') + '.jpg', { type: 'image/jpeg' }));
        }, 'image/jpeg', 0.85);
      };
      img.onerror = function () { URL.revokeObjectURL(url); resolve(file); };
      img.src = url;
    });
  }

  root.querySelectorAll('[data-kp-file]').forEach(function (input) {
    input.addEventListener('change', function () {
      var key = input.dataset.kpFile, f = input.files && input.files[0];
      var box = input.closest('.kp-upload'), status = $('[data-kp-status="' + key + '"]');
      hideError();
      if (!f) { files[key] = null; box.classList.remove('is-done'); status.textContent = 'Add photo'; return; }
      status.textContent = 'Preparing…';
      shrinkImage(f).then(function (out) {
        if (out.size > maxBytes) {
          files[key] = null; box.classList.remove('is-done'); status.textContent = 'Too large';
          showError('That file is too large. Please take a photo instead, or use a file under ' + (CFG.maxFileMb || 15) + ' MB.');
          return;
        }
        files[key] = out; box.classList.add('is-done'); status.textContent = 'Added ✓';
      });
    });
  });

  /* ---------- submit ---------- */
  var err = $('[data-kp-error]'), btn = $('[data-kp-pay]');
  function showError(msg) { err.textContent = msg; err.hidden = false; }
  function hideError() { err.hidden = true; }
  function busy(on, label) { btn.disabled = on; btn.textContent = label || 'Continue to payment'; }

  // Fill Shopify checkout with what the customer already typed at the kiosk, for both the shipping
  // and the billing address: email, name and phone always; street, city, state and ZIP when they
  // chose "We come to you".
  function checkoutPrefill() {
    var p = [], add = function (k, v) { if (v) p.push(encodeURIComponent(k) + '=' + encodeURIComponent(v)); };
    var name = String(order.n || '').trim().split(/\s+/);
    var digits = String(order.p || '').replace(/\D/g, '');
    add('checkout[email]', order.e);
    ['checkout[shipping_address]', 'checkout[billing_address]'].forEach(function (addr) {
      add(addr + '[first_name]', name[0]);
      add(addr + '[last_name]', name.slice(1).join(' '));
      add(addr + '[phone]', digits ? (digits.length === 10 ? '+1' + digits : '+' + digits) : '');
      add(addr + '[country]', 'United States');
      if (order.a) {
        add(addr + '[address1]', order.a.street);
        add(addr + '[city]', order.a.city);
        add(addr + '[province]', order.a.state || 'TX');
        add(addr + '[zip]', order.a.zip);
      }
    });
    return p.length ? '?' + p.join('&') : '';
  }

  function post(url, body) {
    var opts = { method: 'POST', headers: { Accept: 'application/json' }, body: body };
    if (!(body instanceof FormData)) { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body || {}); }
    return fetch(url, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok) { var e = new Error(data.description || data.message || 'Request failed'); e.status = r.status; throw e; }
        return data;
      });
    });
  }

  // Draft-order checkout (chosen in the kiosk admin): the kiosk server builds the Shopify order with the
  // kiosk's prices (from the quote the kiosk signed, not from this link) and returns its payment link.
  // Name, email and address are filled in on the order itself.
  function draftCheckout() {
    var fd = new FormData();
    fd.append('order', JSON.stringify(order));
    if (needDocs) {
      fd.append('id', files.id, files.id.name);
      fd.append('reg', files.reg, files.reg.name);
      fd.append('consent', '1');
    }
    busy(true, needDocs ? 'Uploading your photos…' : 'Preparing checkout…');
    fetch(API + '/checkout/draft', { method: 'POST', body: fd, credentials: 'omit' })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (d) {
          if (!r.ok || !d.url) { var e = new Error(d.error || 'Checkout failed'); e.status = r.status; throw e; }
          return d;
        });
      })
      .then(function (d) {
        busy(true, 'Opening checkout…');
        report('phone_checkout');
        window.location.href = d.url;
      })
      .catch(function (ex) {
        busy(false);
        logIssue('error', 'draft_checkout_failed', 'Draft-order checkout failed: ' + ex.message, { status: ex.status || null, docs: needDocs });
        showError(ex.status ? ex.message : 'Something went wrong. Please check your connection and try again.');
      });
  }

  root.querySelector('form').addEventListener('submit', function (e) {
    e.preventDefault();
    hideError();
    if (needDocs) {
      if (!files.id || !files.reg) return showError('Please add both photos: your photo ID and your registration or title.');
      if (!$('[data-kp-consent]').checked) return showError('Please confirm that you own the vehicle or are authorized by the owner.');
    }
    if (order.cm === 'draft') {
      // Never fall back to the cart: it would charge website prices, not the kiosk's price.
      if (!API) return showError('Checkout isn’t available right now. Please ask our team for help.');
      draftCheckout();
      return;
    }

    var fd = new FormData();
    fd.append('id', order.v);
    fd.append('quantity', order.q);
    fd.append('properties[Car]', order.car || '');
    fd.append('properties[Service]', lost ? 'Lost key' : 'Spare key');
    fd.append('properties[Key type]', KEY_TYPES[order.kt] || order.kt || '');
    fd.append('properties[Location]', order.ln || LOCATIONS[order.loc] || order.loc || '');
    if (order.a) fd.append('properties[Service address]', [order.a.street, order.a.city, order.a.zip].join(', '));
    if (order.w) fd.append('properties[When]', WHEN[order.w] || order.w || '');
    fd.append('properties[_Kiosk]', order.k || '');
    fd.append('properties[_Session]', order.s || '');
    if (needDocs) {
      fd.append('properties[Photo ID]', files.id, files.id.name);
      fd.append('properties[Registration or title]', files.reg, files.reg.name);
      fd.append('properties[_Ownership confirmed]', 'Yes');
    }

    busy(true, needDocs ? 'Uploading your photos…' : 'Preparing checkout…');
    post('/cart/clear.js')
      .then(function () { return post('/cart/add.js', fd); })
      .then(function () {
        var extra = [];
        var tag = { _Kiosk: order.k || '', _Session: order.s || '' };
        if (order.sv) extra.push({ id: order.sv, quantity: order.q, properties: Object.assign({ 'For': order.kn || '', 'Car': order.car || '' }, tag) });
        if (order.f) extra.push({ id: order.f, quantity: 1, properties: tag });
        if (extra.length) return post('/cart/add.js', { items: extra });
      })
      .then(function () {
        return post('/cart/update.js', { attributes: {
          'Kiosk': order.k || '', 'Kiosk session': order.s || '', 'Customer name': order.n || '', 'Customer phone': order.p || ''
        } });
      })
      .then(function () {
        busy(true, 'Opening checkout…');
        report('phone_checkout');
        window.location.href = '/checkout' + checkoutPrefill();
      })
      .catch(function (ex) {
        busy(false);
        logIssue(ex.status === 422 ? 'warn' : 'error', 'cart_failed', 'Could not add the order to the cart: ' + ex.message, { status: ex.status || null, docs: needDocs });
        if (ex.status === 422) showError('Sorry, this key just sold out or is no longer available. Please ask our team for help.');
        else showError('Something went wrong. Please check your connection and try again.');
      });
  });
})();
